const ProfileGridTypes = {
  BASE: 'base',
  DESCRIPTION: 'description',
  CONTACT_INFORMATION: 'contact-information',
  ALL: 'all',
};

module.exports = ProfileGridTypes;
